
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#FFF","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M17 7.5c0-4.35-3.582-7-8-7s-8 2.65-8 7m16.508 4.538c0 4.97-2.184 6.472-5.404 6.536"}}),_c('rect',{attrs:{"x":".5","y":"7.5","width":"3","height":"6","rx":"1.5"}}),_c('rect',{attrs:{"x":"14.5","y":"7.5","width":"3","height":"6","rx":"1.5"}}),_c('rect',{attrs:{"x":"6.5","y":"17.5","width":"6","height":"2","rx":"1"}})])])
          )
        }
      }
    